var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"chart"}},[(_vm.dataLoaded)?_c('apexcharts',{attrs:{"type":"area","height":"300","options":_vm.barChartOptions,"series":_vm.series}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }